import React from 'react';
import PartialScores from '../common/PartialScores';

function getLiveInfo(match) {
    let final = [];
    if (!match.score.currentMinute && match.score.periodo?.length > 0) {
        final.push(<span className='periodo__wrapper' key={match.uniqueId}>{match.score.periodo}</span>);
    }
    if (match.score.currentMinute) {
        if (final == null) {
            final = '';
        }
        final.push(
            <span key={`${match.uniqueId}-container`}> {match.score.periodo == "Intervallo"
                ?
                <div  className='matchScore__periodo'>INT.</div>
                :
                <PartialScores match={match} />
            }
                <span className='currentMinute__wrapper'>{match.score.currentMinute}</span></span>);
    }
    return final;
}

export default function LiveMinutes(props) {
    if (props.match.score == null) {
        return null;
    }

    const info = getLiveInfo(props.match);

    if (info.length === 0) {
        return null;
    }

    return info;
}
